<template>
  <v-app id="inspire">
      <v-overlay :value="loading"></v-overlay>
    <v-card class="ma-4">
      <v-card-title>
        Liste des vadeurs
        <v-spacer></v-spacer>
        <v-icon color="success" dark @click="addVadeur"   >mdi-account-plus</v-icon>
        
      </v-card-title>
        <v-card-text class="col-lg-4 col-md-4 col-sm-6 col-xs-12" right>
        <v-spacer></v-spacer>
        <v-text-field 
          v-model="search"
          append-icon="mdi-magnify"
          label="Rechercher"
          single-line
          hide-details
        ></v-text-field>
        </v-card-text>
      <v-data-table
        :headers="headers"
        :items="vadeurs"
        :search="search"
      >
      <template v-slot:item.deleteBtn="{ item }">
        <v-btn @click="deleteItem(item)" color="error" :loading="loading && item.idUser == index">
          <v-icon >mdi-trash-can</v-icon>
        </v-btn>
      </template>
      </v-data-table>
    </v-card>
    <AddVad  @reloadVadList = "reloadValdList"   @closeDialogAddVad = "closeDialogAddVad" v-if="dialogAddVad"/>
  </v-app>
</template>

<script>
  import {UserService} from '../../providers/UserService.js';
  import AddVad from './AddVad.vue'
const userService = new UserService();
export default {
  components: {
    AddVad
  },
    name: 'Connexion',
  data() {
    return {
      search: '',
      dialogAddVad : false,
      index:-1,
      loading: false,
      headers: [
        {text: 'Nom',align: 'start',value: 'nom'},
        { text: 'Prénom', value: 'prenom' },
        { text: 'Téléphone (Login)', value: 'tel' },
        { text: 'UUID', value: 'uuid' },
        { text: 'Site', value: 'site' },
        { text: 'Code vendeur', value: 'codevendeur' },
        { text: '', value: 'deleteBtn', sortable: false, align: 'center'}
      ],
      vadeurs:[]
    };
  },
  mounted (){
    this.getListeVadeurs();
  },
  methods: {
      closeDialogAddVad: function(){
        this.dialogAddVad = false;
      },
      reloadValdList: function(){
        this.dialogAddVad = false;
        this.getListeVadeurs();
      },
      addVadeur: function(){
        this.dialogAddVad = true;
       
      },
      getListeVadeurs: function(){
        this.$root.progress = true;
        userService.getListeVadeurs().then(res => { 
          this.$root.progress = false;
          if(res){
            if (res.err !='error') {
              this.vadeurs = res.params;
                         
            }else{
              this.$dialog.error({
                text: res.err_msg,
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
            
            }
          }
        }).catch(error=>{
    
              this.loading = false;
              this.$dialog.notify.error(this.$root.errorMessage, {
                        position: 'bottom-right',
                        timeout: 5000
                      })
            return error;
          })
          
        
      },
      deleteItem:async function(vadeur){
           await this.$dialog.confirm({
          text: 'Etes vous certain de vouloir supprimer ce vadeur?',
          type:'warning',
          title: 'Alert',
          actions: {
            false: 'Non',
            true: {
              color: 'red',
              text: 'Oui',
              handle: () => {
                this.deleteVadeur(vadeur);
              }
            }
          }
        })
      },
      deleteVadeur: function(vadeur){
       
        this.index = vadeur.idUser;
        this.loading = true;
        userService.deleteVadeur(vadeur.idUser).then(res => { 
          this.loading = false;
          this.index = -1;
          if(res){
            if (res.err !='error') {
              this.$dialog.notify.success(res.err_msg, {
                position: 'top-right',
                timeout: 5000
              })
              this.getListeVadeurs();
                         
            }else{
              this.$dialog.error({
                text: res.err_msg,
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
            
            }
          }
        }).catch(error=>{
    
              this.loading = false;
              this.$dialog.notify.error(this.$root.errorMessage, {
                        position: 'bottom-right',
                        timeout: 5000
                      })
            return error;
          })
          
       
      }
  }
};
  
</script>
